import React from 'react';
import { useHistory } from "react-router";
import { getPeerComparison } from "api/urls";
import { getQueryParams } from 'utils/Utils';
import TableContainer from 'components/wrapper/TableContainer';

const labelMapping = {
    market_cap: { acronym: 'MCAP', full: 'Market Capitalization' },
    enterprise_value: { acronym: 'EV', full: 'Enterprise Value' },
    number_of_share: { acronym: 'SO', full: 'Shares Outstanding' },
    price_to_earning_ratio: { acronym: 'PE', full: 'Price-to-Earnings Ratio' },
    price_to_book_value: { acronym: 'PB', full: 'Price-to-Book Ratio' },
    face_value: { acronym: 'FV', full: 'Face Value' },
    dividend_yield: { acronym: 'DY', full: 'Dividend Yield' },
    book_value: { acronym: 'BVPS', full: 'Book Value Per Share' },
    cash: { acronym: 'Cash', full: 'Cash' },
    debt: { acronym: 'Debt', full: 'Debt' },
    promoter_holding: { acronym: 'PH', full: 'Promoter Holding' },
    eps: { acronym: 'EPS', full: 'Earnings Per Share' },
    sales_growth: { acronym: 'SG', full: 'Sales Growth' },
    roe: { acronym: 'ROE', full: 'Return on Equity' },
    roce: { acronym: 'ROCE', full: 'Return on Capital Employed' },
    profit_growth: { acronym: 'PG', full: 'Profit Growth' },
};

const PeerComparison = (props) => {

    const history = useHistory()
    const url=getQueryParams(history.location.search)
    const unWantedKeys = ['created_at', 'updated_at', 'company_id', 'id','company','symbol']


    return (
        <div  {...props}>
            <TableContainer
                url={getPeerComparison(url.company__symbol)}
                title={"Peer Comparison"}
                unWantedKeys={unWantedKeys}
                labelMapping={labelMapping}
                isCompany={true}
                highlightSymbol={url.company__symbol}
                 />
        </div>
    )
};

export default (PeerComparison);
